import React, { useEffect, useRef } from "react";
import "../../styles/Navbar.css";
import {
  FaHome,
  FaLaptop,
  FaProjectDiagram,
  FaBars,
  FaTimes,
} from "react-icons/fa";
import { BiBookContent, BiServer, BiEnvelope } from "react-icons/bi";
import { FiUser } from "react-icons/fi";
import { Link } from "react-scroll";
import { Link as RouterLink } from "react-router-dom";
import ProfileImg from "../../images/profile_me.jpg";
import NavLinks from "./NavLinks";
import { motion } from "framer-motion";
import { AnimatePresence } from "framer-motion";

const navVariants = {
  hidden: {
    opacity: 0,
    transition: {
      delay: 0.5,
      staggerChildren: 0.2,
      staggerDirection: -1,
    },
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.5,
      staggerChildren: 0.2,
      staggerDirection: 1,
    },
  },
};

const menuVariants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    scale: [1, 1.2, 1.5, 1.2, 1],
    rotate: [0, 0, 360, 360, 360],
    borderRadius: ["50%", "50%", "50%", "50%", "50%"],
    transition: {
      duration: 1,
    },
  },
};

const Navbar = ({ nav, handleNav }) => {
  const navRef = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        nav &&
        navRef.current &&
        !navRef.current.contains(event.target) &&
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        handleNav();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [nav, handleNav]);

  return (
    <>
      <motion.div
        ref={menuRef}
        variants={menuVariants}
        initial="hidden"
        whileInView="visible"
        onClick={handleNav}
        className="menu-icon"
      >
        {nav ? <FaTimes /> : <FaBars />}
      </motion.div>
      <AnimatePresence>
        <motion.nav
          ref={navRef}
          initial={{ width: "0" }}
          animate={
            nav ? { width: "300px" } : { width: "0", transition: { delay: 1 } }
          }
          className={nav ? "navbar active" : "navbar"}
        >
          <motion.div
            initial="hidden"
            whileInView={nav ? "visible" : "hidden"}
            variants={navVariants}
            exit="hidden"
            className="navbar-container"
          >
            <div className="top-details">
              <div className="img__cover">
                <img
                  src={ProfileImg}
                  alt="Main"
                  className="profile-pic-small"
                />
              </div>
              <Link
                activeClass="active"
                spy={true}
                smooth={true}
                offset={0}
                duration={500}
                onClick={handleNav}
                to="home"
                className="profile-name"
              >
                Neda Kedmati
              </Link>
              <NavLinks handleNav={handleNav} />
            </div>
            <ul className="mid-details">
              <Link
                activeClass="active"
                spy={true}
                smooth={true}
                offset={0}
                duration={500}
                to="home"
                className="mid-links"
              >
                <FaHome className="mid-icon" />
                <li className="mid-link" onClick={handleNav}>
                  Home
                </li>
              </Link>
              <Link
                activeClass="active"
                spy={true}
                smooth={true}
                offset={0}
                duration={500}
                to="about"
                className="mid-links"
              >
                <FiUser className="mid-icon" />
                <li className="mid-link" onClick={handleNav}>
                  About
                </li>
              </Link>
              <Link
                activeClass="active"
                spy={true}
                smooth={true}
                offset={0}
                duration={500}
                to="skills"
                className="mid-links"
              >
                <FaLaptop className="mid-icon" />
                <li className="mid-link" onClick={handleNav}>
                  Skills
                </li>
              </Link>
              <Link
                activeClass="active"
                spy={true}
                smooth={true}
                offset={0}
                duration={500}
                to="services"
                className="mid-links"
              >
                <BiServer className="mid-icon" />
                <li className="mid-link" onClick={handleNav}>
                  Services
                </li>
              </Link>
              {/* <Link
                activeClass="active"
                spy={true}
                smooth={true}
                offset={0}
                duration={500}
                to="works"
                className="mid-links"
              >
                <BiBookContent className="mid-icon" />
                <li className="mid-link" onClick={handleNav}>
                  Works
                </li>
              </Link> */}
              <RouterLink
                to="/projects"
                className="mid-links"
                onClick={handleNav}
              >
                <FaProjectDiagram className="mid-icon" />
                <li className="mid-link">Projects</li>
              </RouterLink>
              <Link
                activeClass="active"
                spy={true}
                smooth={true}
                offset={0}
                duration={500}
                to="contact"
                className="mid-links"
              >
                <BiEnvelope className="mid-icon" />
                <li className="mid-link" onClick={handleNav}>
                  Contact
                </li>
              </Link>
            </ul>
            <div className="copy">
              <small className="copyright">
                © Copyright ©2025 <br /> All rights reserved |
              </small>
            </div>
          </motion.div>
        </motion.nav>
      </AnimatePresence>
    </>
  );
};

export default Navbar;
